// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSocialTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.953 8.048c.006.176.012.354.012.531 0 5.423-4.13 11.675-11.677 11.675-2.317 0-4.47-.68-6.288-1.843.324.037.647.057.976.057a8.245 8.245 0 0 0 5.1-1.757 4.113 4.113 0 0 1-3.835-2.85 4.077 4.077 0 0 0 1.853-.07 4.103 4.103 0 0 1-3.288-4.023v-.052a4.076 4.076 0 0 0 1.859.513 4.093 4.093 0 0 1-1.27-5.478 11.645 11.645 0 0 0 8.458 4.287c-.07-.3-.112-.613-.112-.934a4.107 4.107 0 0 1 7.1-2.808 8.218 8.218 0 0 0 2.606-.996 4.112 4.112 0 0 1-1.806 2.27A8.15 8.15 0 0 0 22 5.924a8.31 8.31 0 0 1-2.047 2.124z"
    />
  </svg>
);
export default SvgSocialTwitter;
